import type { Book } from 'api/data.types'

export const OPEN = '[player] OPEN'
export const open = () => ({
  type: OPEN
})

export const CLOSE = '[player] CLOSE'
export const close = () => ({
  type: CLOSE
})

export const MINIMIZE = '[player] MINIMIZE'
export const minimize = () => ({
  type: MINIMIZE
})

export const MAXIMIZE = '[player] MAXIMIZE'
export const maximize = () => ({
  type: MAXIMIZE
})

export const LOAD_BOOK = '[player] LOAD_BOOK'
export type LoadBookActionType = {
  type: string
  book: Book
}

export const loadBook = (book: Book) =>
  <LoadBookActionType>{
    type: LOAD_BOOK,
    book
  }

export const PLAY = '[player] PLAY'
export const play = () => ({
  type: PLAY
})

export const PAUSE = '[player] PAUSE'
export const pause = () => ({
  type: PAUSE
})

export const OPEN_CHAPTER_LIST = '[player] OPEN_CHAPTERS_LIST'
export const openChaptersList = () => ({
  type: OPEN_CHAPTER_LIST
})

export const CLOSE_CHAPTER_LIST = '[player] CLOSE_CHAPTERS_LIST'
export const closeChaptersList = () => ({
  type: CLOSE_CHAPTER_LIST
})

export const SELECT_CHAPTER = '[player] SELECT_CHAPTER'
export type SelectChapterActionType = {
  type: string
  id: number
}

export const selectChapter = (id: number) =>
  <SelectChapterActionType>{
    type: SELECT_CHAPTER,
    id
  }

export const UPDATE_PROGRESS_BAR = '[player] UPDATE_PROGRESS_BAR'
export type UpdateProgressBarActionType = {
  type: string
  payload: { value: number; isDrag: boolean }
}

export const updateProgressBar = (payload: {
  value: number
  isDrag: boolean
}) =>
  <UpdateProgressBarActionType>{
    type: UPDATE_PROGRESS_BAR,
    payload
  }

export const UPDATE_CURRENT_CHAPTER_PROGRESS =
  '[player] UPDATE_CURRENT_CHAPTER_PROGRESS'
export type UpdateCurrentChapterProgressActionType = {
  type: string
  payload: number
}

export const updateCurrentChapterProgress = (payload: number) =>
  <UpdateCurrentChapterProgressActionType>{
    type: UPDATE_CURRENT_CHAPTER_PROGRESS,
    payload
  }

export const UPDATE_PROGRESS_BAR_MANUAL = '[player] UPDATE_PROGRESS_BAR_MANUAL'
export type UpdateTargetTrackPecentageActionType = {
  type: string
  payload: number
}

export const updateTargetTrackPecentage = (payload: number) =>
  <UpdateTargetTrackPecentageActionType>{
    type: UPDATE_PROGRESS_BAR_MANUAL,
    payload
  }

export const UPDATE_CURRENT_TRACK_TIME = '[player] UPDATE_CURRENT_TRACK_TIME'
export type UpdateCurrentTrackTimeActionType = {
  type: string
  payload: number
}

export const updateCurrentTrackTime = (payload: number) =>
  <UpdateCurrentTrackTimeActionType>{
    type: UPDATE_CURRENT_TRACK_TIME,
    payload
  }

export const UPDATE_VOLUME = '[player] UPDATE_VOLUME'
export type UpdateVolume = {
  type: string
  payload: number
}

export const updateVolume = (payload: number) =>
  <UpdateVolume>{
    type: UPDATE_VOLUME,
    payload
  }

export const FORWARD_TRACK = '[player] FORWARD_TRACK'
export type ForwardTrack = {
  type: string
  payload: boolean
}

export const forwardTrack = (payload: boolean) =>
  <ForwardTrack>{
    type: FORWARD_TRACK,
    payload
  }

export const BACK_TRACK = '[player] BACK_TRACK'
export type BackTrack = {
  type: string
  payload: boolean
}

export const backTrack = (payload: boolean) =>
  <BackTrack>{
    type: BACK_TRACK,
    payload
  }

export const UPDATE_RATE = '[player] UPDATE_RATE'
export type UpdateRate = {
  type: string
  payload: number
}

export const updateRate = (payload: number) =>
  <UpdateRate>{
    type: UPDATE_RATE,
    payload
  }

export const LOADING = '[player] LOADING'
export type Loading = {
  type: string
  payload: boolean
}

export const loading = (payload: boolean) =>
  <Loading>{
    type: LOADING,
    payload
  }

export const UPDATE_CHAPTER_HAS_LISTENED =
  '[player] UPDATE_CHAPTER_HAS_LISTENED'
export type UpdateChapterHasListened = {
  type: string
  payload: { id: number }
}

export const updateChapterHasListened = (payload: { id: number }) =>
  <UpdateChapterHasListened>{
    type: UPDATE_CHAPTER_HAS_LISTENED,
    payload
  }

export const SET_PREVIEW = '[player] SET_PREVIEW'
export type SetPreview = {
  type: string
  payload: boolean
}

export const setPreview = (payload: boolean) =>
  <SetPreview>{
    type: SET_PREVIEW,
    payload
  }

export const SET_PREVIEW_LIMIT_REACHED = '[player] SET_PREVIEW_LIMIT_REACHED'
export type SetPreviewLimitReached = {
  type: string
  payload: boolean
}

export const setPreviewLimitReached = (payload: boolean) =>
  <SetPreviewLimitReached>{
    type: SET_PREVIEW_LIMIT_REACHED,
    payload
  }

export type PlayerActions = ReturnType<
  | typeof open
  | typeof close
  | typeof minimize
  | typeof maximize
  | typeof loadBook
  | typeof play
  | typeof pause
  | typeof openChaptersList
  | typeof closeChaptersList
  | typeof selectChapter
  | typeof updateProgressBar
  | typeof updateCurrentChapterProgress
  | typeof updateTargetTrackPecentage
  | typeof updateCurrentTrackTime
  | typeof updateVolume
  | typeof forwardTrack
  | typeof backTrack
  | typeof updateRate
  | typeof loading
  | typeof updateChapterHasListened
  | typeof setPreview
  | typeof setPreviewLimitReached
>
